import {FormikProps} from 'formik'
import {IRouteOptions} from './modal/RouteManageForm'
import {RouteManageFormValuesType} from './_model'
import {useMemo, useState} from 'react'
import {ListChildComponentProps, FixedSizeList as List} from 'react-window'
import {KTIcon} from '../../../_metronic/helpers'

type Props = {
  routeOptions: IRouteOptions[]
  formik: FormikProps<RouteManageFormValuesType>
}

interface ListChildProps extends ListChildComponentProps {
  data: {
    items: IRouteOptions[]
    selectType: 'source' | 'destination'
    onSelect: (type: 'source' | 'destination', item: IRouteOptions) => void
  }
}

const Row = ({index, style, data}: ListChildProps) => {
  const item = data.items[index]

  const onHandleSelect = () => {
    data.onSelect(data.selectType, item)
  }

  return (
    <div
      style={style}
      className='cursor-pointer bg-hover-danger rounded px-4 py-3'
      onClick={onHandleSelect}
    >
      {item.value}
    </div>
  )
}

const RouteSelection = ({routeOptions, formik}: Props) => {
  const [sourceRouteSearch, setSourchRouteSearch] = useState('')
  const [destinationRouteSearch, setDestinationRouteSearch] = useState('')

  const filteredSourceRoute = useMemo(() => {
    return routeOptions.filter((item) =>
      item.value.toLowerCase().includes(sourceRouteSearch.toLowerCase())
    )
  }, [sourceRouteSearch, routeOptions])

  const filteredDestinationRoute = useMemo(() => {
    return routeOptions.filter((item) =>
      item.value.toLowerCase().includes(destinationRouteSearch.toLowerCase())
    )
  }, [destinationRouteSearch, routeOptions])

  const handleSelect = (type: 'source' | 'destination', item: IRouteOptions) => {
    if (type === 'source') {
      formik.setFieldValue('sourceRoute', item)
    } else {
      formik.setFieldValue('destinationRoute', item)
    }
  }

  return (
    <div className='d-flex gap-8 mb-7'>
      <div>
        <h3>Source Route</h3>
        <p className='p-4 bg-light rounded mb-3 text-gray-700'>
          {formik.values.sourceRoute ? formik.values.sourceRoute.value : 'Not Selected'}
        </p>

        <div className='bg-light w-100 mt-5 rounded'>
          <input
            placeholder='Search'
            type='text'
            value={sourceRouteSearch}
            onChange={(e) => setSourchRouteSearch(e.target.value)}
            className='form-control custom-input'
          />
          <div className='w-100'>
            <List
              height={300}
              itemCount={filteredSourceRoute.length}
              itemSize={40}
              width={'100%'}
              itemData={{
                items: filteredSourceRoute,
                selectType: 'source',
                onSelect: handleSelect,
              }}
            >
              {Row}
            </List>
          </div>
        </div>
      </div>

      <div>
        <h3>Destination Route</h3>
        <p className='p-4 bg-light rounded mb-3 text-gray-700'>
          {formik.values.destinationRoute ? formik.values.destinationRoute.value : 'Not Selected'}
        </p>
        <div className='bg-light w-100 mt-5 rounded'>
          <input
            placeholder='Search'
            type='text'
            value={destinationRouteSearch}
            onChange={(e) => setDestinationRouteSearch(e.target.value)}
            className='form-control custom-input'
          />
          <div className='w-100'>
            <List
              height={300}
              itemCount={filteredDestinationRoute.length}
              itemSize={40}
              width={'100%'}
              itemData={{
                items: filteredDestinationRoute,
                selectType: 'destination',
                onSelect: handleSelect,
              }}
            >
              {Row}
            </List>
          </div>
        </div>
      </div>

      <div>
        {formik.values.sourceRoute ? (
          <>
            <div className='text-gray-800 fs-4 d-flex align-items-center gap-2'>
              Source
              <KTIcon iconName='arrow-right' className='fs-2hx' />
              Destination
            </div>
            <div className='text-gray-700 fs-4 d-flex align-items-center gap-2'>
              {formik.values.sourceRoute.value}
              <KTIcon iconName='arrow-right' className='fs-2hx' />
              {formik.values.destinationRoute
                ? formik.values.destinationRoute.value
                : 'Not Selected'}
            </div>
          </>
        ) : (
          <></>
        )}
      </div>
    </div>
  )
}

export default RouteSelection
